import React from 'react'

const LedgerDefault = ({ onSearchForm }) => (
  <div className="jumbotron">
    <h1>Student Ledger Module.</h1>
    <hr/>
    <button type="button" onClick={onSearchForm} className="btn btn-warning">Search Student</button>
  </div>
)

export default LedgerDefault



// WEBPACK FOOTER //
// ./src/containers/Ledger/default.js